import React from 'react';
import { FlexColumn } from 'styles/Layout';
import styled from 'styled-components';
import { ExternalTenantAssets } from 'utils/ExportCommon';
import { media } from 'styles/Mixins';

const Container = styled(FlexColumn)`
  position: relative;
  min-height: 560px;
  background-color: #ffffff;
  overflow: hidden;
  ${media.sm`
    min-height: 358px;
  `};
  ${media.md`
    min-height: 445px;
  `};
`;

const TextContainer = styled(FlexColumn)`
  position: absolute;
  bottom: 52px;
  left: 27px;
  width: 295px;
  ${media.sm`  
    bottom: 100px;
    left: 30px;
  `};
  ${media.md`  
    left: 58px;
  `};
`;

const Title = styled.h1`
  min-height: 47px;
  width: 284px;
  font-size: 24px;
  line-height: 29px;
  font-weight: bold;
  color: #ffffff;
  margin: 0 0 11px 0;
  ${media.sm`  
    margin: 0 0 17px 0;
  `};
`;

const Text = styled.span`
  width: 295px;
  font-size: 14px;
  line-height: 17px;
  font-weight: 500;
  color: #ffffff;
  ${media.sm`
    
  `};

  ${media.md`
    width: 361px;
    font-size: 16px;
    line-height: 19px;
  `};
`;

const CoverImage = styled.img`
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  height: 358px;
  width: 824px;
  ${media.sm`
    display: block;
  `};
  ${media.md`
    height: 445px;
    width: 1024px;
  `};
`;
const CoverImageMobile = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  height: auto;
  width: 100%;
  ${media.sm`
    display: none;
  `};
`;

export default function InfoSection() {
  return (
    <Container>
      <CoverImageMobile src={ExternalTenantAssets.IndexCoverMobile} />
      <CoverImage src={ExternalTenantAssets.IndexCover} />
      <TextContainer>
        <Title>¿Quieres rentar un depa sin papeleo y en horas?</Title>
        <Text>
          Homie es tu solución. Aunque el depa que quieres no esté en nuestra
          plataforma, nosotros te respaldamos y certificamos como inquilino, te
          acompañamos en el proceso para que envíes una solicitud al propietario
          del inmueble.
        </Text>
      </TextContainer>
    </Container>
  );
}
